import React from "react";
import BreadCrumb from "../../Components/BreadCrumb";
import Judgement from "./Judgement";

const JudgementPage = (benchId) => {
  return (
    <>
      <div className="col-12 col-sm-12 col-md-9 col-lg-9">
        <BreadCrumb title="Judgement" />
        <div className="about-bg inner-page-section">
          <div className="container">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <Judgement benchId={benchId} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default JudgementPage;
